package de.ohhhmhhh.frontend.admin.ui.components.buttons

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.I
import org.jetbrains.compose.web.dom.Text

@Composable
fun BackLink(link: String) {
    A(href = link, {
        style {
            color(Color.black)
            cursor("pointer")
        }
    }) {
        I({
            classes("fa-solid", "fa-arrow-left")
            style { marginRight(8.pt) }
        }) {}
        Text("zurück")
    }
}